var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiltersActive = function SvgFiltersActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.945 9.926a6 6 0 0 1-1.072.073 1.413 1.413 0 0 1-2.693-.702q-.481-.257-.905-.593a2.6 2.6 0 0 0-.1.708c0 1.128.774 2.075 1.82 2.34L18 21h1l-.006-9.21a2.415 2.415 0 0 0 1.951-1.864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.994 5.245 5 3h1l-.006 2.245c1.052.26 1.831 1.245 1.831 2.376 0 1.132-.774 2.117-1.825 2.377V21H5V9.998a2.413 2.413 0 0 1-.006-4.753M4 7.621a1.413 1.413 0 1 1 2.825 0 1.413 1.413 0 0 1-2.825 0M11.5 3v7.028a2.413 2.413 0 0 0 0 4.721V21h1v-6.25a2.413 2.413 0 0 0 0-4.722V3zm.5 7.976a1.413 1.413 0 1 0 0 2.825 1.413 1.413 0 0 0 0-2.825",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C80000",
    d: "M24 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
export default SvgFiltersActive;